import {
	getCancelToken,
	httpGetRequest,
	httpGetRequestBlobWithCredentials,
} from "../../../clients/phronesisClient"
import { ReportType } from "components/Transactional/SelloutReport/ReportsTable"
import { mapSelloutReportItems, ReportMapEntry } from "./reports.mapper"

const GET_SELLOUT_REPORTS_URL = "/reports/sellout-reports"
const NUMBER_RETRIES = 0
const cancelToken = getCancelToken().token

export interface SelloutReportItem {
	date: string
	endDate: string
	filename: string
	reportType: ReportType
	period?: string
}

export const getSelloutReports = async (
	cancelToken: any,
	params?: any,
	customTimeout?: number,
	headers?: any
): Promise<Array<ReportMapEntry>> => {
	// customHeaders is temporal only. Please remove after successful release.
	const customHeaders = { ...headers, useFileNamingConventionV2: true }
	const response = await httpGetRequest<{
		reports: Array<SelloutReportItem>
	}>(
		GET_SELLOUT_REPORTS_URL,
		params,
		customTimeout,
		cancelToken,
		customHeaders,
		NUMBER_RETRIES
	)

	const reports = response.reports.map(
		({ date, endDate, filename, reportType }) => ({
			date,
			endDate,
			filename,
			reportType: reportType as ReportType,
		})
	)
	return mapSelloutReportItems(reports)
}

const contentType = "application/octet-stream"
export const getSelloutReportFile = async (
	params?: any,
	customTimeout?: number,
	headers?: any
): Promise<Blob> => {
	headers = { ...headers, "Content-Type": contentType }
	const endpoint = `${GET_SELLOUT_REPORTS_URL}/${params.id}`
	const response = await httpGetRequestBlobWithCredentials(
		endpoint,
		cancelToken,
		customTimeout,
		undefined,
		headers,
		NUMBER_RETRIES
	)

	return response as Blob
}
